<template>
  <ul :class="classes.list">
    <li :class="classes.listItem" v-for="option in options">
      <component :is="optionComponent" :is-active="value == option.id" :id="option.id" :label="option.label" :image="option.image" :icon="option.icon" :color="option.color" v-on:select="handleSelectItem" />
    </li>
  </ul>
</template>

<script type="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import BoxesItem from './BoxesItem';
import BoxesRow from './BoxesRow';
import {Image} from './interfaces';

interface BoxesItemOption {
  id: number | string,
  title: string,
  color: string,
  icon?: string,
  image?: Image,
  selected?: boolean
}

interface BoxesListClasses {
  list: string,
  listItem: string
}

@Component({
  components: {BoxesItem, BoxesRow}
})
export default class BoxesList extends Vue {
  @Prop({default: null}) value: String | Number;
  @Prop({default: () => [], type: Array}) options: Array<BoxesItemOption>;
  @Prop({default: 'boxes-item', type: String}) optionComponent: String;

  @Prop({default: () => {
      return {
        list: 'filter__boxes-list',
        listItem: 'filter__boxes-list__item'
      }
    }, type: Object}) classes: BoxesListClasses;

  private handleSelectItem(id) {
    this.$emit('input', id);
  }
}
</script>